import * as React from 'react';
const SvgCloud = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={240}
    height={240}
    fill="none"
    viewBox="0 0 240 240"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h240v240H0z" />
    <path
      fill="#E9F2FF"
      d="M120 204c46.392 0 84-37.608 84-84s-37.608-84-84-84-84 37.608-84 84 37.608 84 84 84"
    />
    <path
      fill="#59F"
      fillRule="evenodd"
      d="M175 172c24.853 0 45-20.147 45-45 0-19.771-12.751-36.564-30.477-42.605C185.785 54.848 160.561 32 130 32c-22.412 0-41.954 12.288-52.256 30.495C107.223 66.294 130 91.487 130 122h-10c0-26.48-20.585-48.152-46.625-49.888A51 51 0 0 0 70 72c-27.614 0-50 22.386-50 50s22.386 50 50 50z"
      clipRule="evenodd"
    />
    <path
      fill="#CDF"
      fillRule="evenodd"
      d="M187.5 195.398a1.9 1.9 0 0 0 1.904-1.898 1.9 1.9 0 0 0-1.904-1.898 1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898m0 2.602a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M179.5 33.398a1.9 1.9 0 0 0 1.904-1.898 1.9 1.9 0 0 0-1.904-1.898 1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898m0 2.602a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
      clipRule="evenodd"
    />
    <path
      fill="#59F"
      d="M83.009 23.568c.504-2.09 3.478-2.09 3.982 0l.765 3.166c.18.747.763 1.33 1.51 1.51l3.166.765c2.09.504 2.09 3.478 0 3.982l-3.166.765c-.747.18-1.33.763-1.51 1.51l-.765 3.166c-.504 2.09-3.478 2.09-3.982 0l-.765-3.166a2.05 2.05 0 0 0-1.51-1.51l-3.166-.765c-2.09-.504-2.09-3.478 0-3.982l3.166-.765a2.05 2.05 0 0 0 1.51-1.51zM136.896 215.655c.534-2.207 3.674-2.207 4.208 0l.712 2.941a2.17 2.17 0 0 0 1.597 1.595l2.929.705c2.211.532 2.211 3.676 0 4.208l-2.929.705a2.17 2.17 0 0 0-1.597 1.595l-.712 2.941c-.534 2.207-3.674 2.207-4.208 0l-.712-2.941a2.17 2.17 0 0 0-1.597-1.595l-2.929-.705c-2.211-.532-2.211-3.676 0-4.208l2.929-.705a2.17 2.17 0 0 0 1.597-1.595z"
    />
    <path
      fill="#8BF"
      d="M58.514 201.578c-.338-1.343.908-2.546 2.242-2.166l7.337 2.09c1.334.38 1.756 2.058.759 3.021l-5.482 5.294c-.997.962-2.664.487-3.002-.855z"
    />
    <path
      fill="#CDF"
      d="M232 75.272a10.7 10.7 0 0 1-2.657 7.071A10.74 10.74 0 0 1 221.252 86H185.52a14.5 14.5 0 0 1-2.314-.19 13.5 13.5 0 0 1-8.307-4.94 13.47 13.47 0 0 1 1.167-17.993 13.5 13.5 0 0 1 8.875-3.828 19 19 0 0 1 8.257-8.777 19.04 19.04 0 0 1 22.613 3.438 18.98 18.98 0 0 1 5.267 10.833h.162a10.76 10.76 0 0 1 7.608 3.137A10.73 10.73 0 0 1 232 75.272M20 52.073a7.94 7.94 0 0 0 2.314 5.605A7.9 7.9 0 0 0 27.903 60h26.234a9.9 9.9 0 0 0 6.904-2.858 9.96 9.96 0 0 0 2.958-6.88 9.97 9.97 0 0 0-2.666-6.999 9.9 9.9 0 0 0-6.779-3.148 14 14 0 0 0-6.066-6.448 13.94 13.94 0 0 0-8.71-1.508 13.96 13.96 0 0 0-7.87 4.038 14.04 14.04 0 0 0-3.88 7.967h-.12a7.9 7.9 0 0 0-5.584 2.313A7.94 7.94 0 0 0 20 52.073M32 167.53a8.5 8.5 0 0 0 2.081 5.58 8.38 8.38 0 0 0 5.217 2.812q.552.078 1.108.078h27.946a11 11 0 0 0 1.818-.151 10.55 10.55 0 0 0 6.543-3.886 10.7 10.7 0 0 0 2.265-7.304 10.68 10.68 0 0 0-3.184-6.947 10.53 10.53 0 0 0-6.987-3 14.94 14.94 0 0 0-6.46-6.921 14.8 14.8 0 0 0-9.293-1.62 14.84 14.84 0 0 0-8.392 4.332 15.04 15.04 0 0 0-4.124 8.544h-.131a8.36 8.36 0 0 0-5.95 2.486 8.5 8.5 0 0 0-1.821 2.752A8.5 8.5 0 0 0 32 167.53"
    />
  </svg>
);
export default SvgCloud;
